import React from "react";
import { connect } from "react-redux";
import { debug, sortObjectsByAlphabet } from "../utils";


function UserRoleField({ userRoles, userRoleId, onChange, valid, disabled, required = false }) {

    // const onChange = (value) => {
    //     selectUserRoleId(value);
    //     //const userRole = userRoles.find(userRole => userRole.id === Number(value));
    //     //setUserRoleId(value);
    //     // modalDataService.changeGroup(group)
    // };

    const userRoleCopy = sortObjectsByAlphabet(userRoles, 'name');

    return (
        <div className="form-group oct_auth-user-field">
            <div className="oct_auth-user-form-group">
                <label htmlFor="userRole" className="oct_auth-user-label">
                    User Role
                    {required && <span className="modal-v2-required-mark">*</span>}
                </label>
                <select id="userRole"
                    className={`form-control oct_auth-user-select ${valid ? '' : 'border-danger'}`}
                    value={userRoleId}
                    onChange={event => onChange(event.target.value)}
                    disabled={disabled}>

                    <option value={-1}>Choose</option>
                    {
                        userRoleCopy &&
                        userRoleCopy.map((userRole, index) => <option key={index} value={userRole.id}>{userRole.name}</option>)
                    }
                </select>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("UserRoleField mapStateToProps", state);
    const authPage = state.authPage;
    const userRole = authPage.userRole;
    return {
        //userRoles: authPage.userRole || [],
        userRolesId: userRole ? userRole.id : null
    };
}

export default connect(mapStateToProps)(UserRoleField);
